import './Loadings.css';

const Loadings = () => {
  return (
    <>
      <div className="flex justify-center">
        <div className="loadingio-spinner-spinner-w3kwwsv7i0k">
          <div className="ldio-ra13xgbwmkd">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Loadings;